// Import all assets
import microsoftLogo from '../assets/microsoft-svgrepo-com.svg';
import googleLogo from '../assets/google-color-svgrepo-com.svg';
import awsLogo from '../assets/aws-svgrepo-com.svg';
import openaiLogo from '../assets/openai-svgrepo-com.svg';
import salesforceLogo from '../assets/salesforce-svgrepo-com.svg';
import githubLogo from '../assets/github-142-svgrepo-com.svg';
import metaLogo from '../assets/meta-color.svg';
import slackLogo from '../assets/slack-svgrepo-com.svg';
import n8nLogo from '../assets/n8n-color.svg';

export default function OneAIBrandNetwork() {
  const logos = [
    { src: microsoftLogo, alt: 'Microsoft', scale: 1 },
    { src: googleLogo, alt: 'Google', scale: 1 },
    { src: awsLogo, alt: 'AWS', scale: 0.9 },
    { src: openaiLogo, alt: 'OpenAI', scale: 1 },
    { src: salesforceLogo, alt: 'Salesforce', scale: 1 },
    { src: githubLogo, alt: 'GitHub', scale: 1, offsetY: -2 },
    { src: metaLogo, alt: 'Meta', scale: 0.9 },
    { src: slackLogo, alt: 'Slack', scale: 1 },
  ];

  // Arrange logos in a circle
  const r = 85; // radius from center to logos
  const cx = 120; // increased center x
  const cy = 120; // increased center y

  return (
    <div className="flex justify-center">
      <svg width="240" height="240" className="drop-shadow-lg">
        {/* Spokes - drawn first so they appear behind */}
        {logos.map((_, i) => {
          const angle = (2 * Math.PI * i) / logos.length - Math.PI / 2;
          const lx = cx + r * Math.cos(angle);
          const ly = cy + r * Math.sin(angle);
          
          return (
            <line 
              key={`spoke-${i}`}
              x1={cx} 
              y1={cy} 
              x2={lx} 
              y2={ly} 
              stroke="#222532" 
              strokeWidth={3}
              opacity={0.8}
            />
          );
        })}
        
        {/* Center hub - drawn after spokes so it appears on top */}
        <circle cx={cx} cy={cy} r={22} fill="white" stroke="#222532" strokeWidth={2} />
        <image
          x={cx - 18}
          y={cy - 18}
          width={36}
          height={36}
          href={n8nLogo}
        />
        
        {/* Logo containers and images */}
        {logos.map((logo, i) => {
          const angle = (2 * Math.PI * i) / logos.length - Math.PI / 2;
          const lx = cx + r * Math.cos(angle);
          const ly = cy + r * Math.sin(angle) + (logo.offsetY || 0);
          const logoSize = 32 * (logo.scale || 1);
          
          return (
            <g key={`logo-${i}`}>
              {/* Logo container with background */}
              <circle 
                cx={lx} 
                cy={ly} 
                r={18} 
                fill="white" 
                stroke="#222532" 
                strokeWidth={2}
                opacity={1}
              />
              {/* Logo as image */}
              <image
                x={lx - logoSize/2}
                y={ly - logoSize/2}
                width={logoSize}
                height={logoSize}
                href={logo.src}
              />
            </g>
          );
        })}
      </svg>
    </div>
  );
}
